import { faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Badge } from "react-bootstrap";

const CellBadge = ({ label }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center border border-1 rounded-3 bg-light px-2 py-1 "
      style={{ fontSize: "0.75rem" }}
    >
      <FontAwesomeIcon icon={faUser} className="me-2" />
      {label}
    </div>
  );
};

export default CellBadge;
